<template>
  <div class="instagram-feed">
    <h2 class="instagram-feed__title">
      <span class="instagram-icon"><i class="fab fa-instagram"></i></span>
      Stay Updated On Instagram <a href="https://www.instagram.com/buildthenbless/" target="_blank"></a>
    </h2>
    
    <div v-if="loading" class="instagram-feed__loading">
      <p>Loading latest posts...</p>
    </div>
    
    <div v-else-if="error" class="instagram-feed__error">
      <p>{{ error }}</p>
    </div>
    
    <div v-else class="instagram-feed__grid">
      <a 
        v-for="post in posts" 
        :key="post.id" 
        :href="post.permalink" 
        target="_blank"
        class="instagram-feed__item"
      >
        <img :src="post.media_url" :alt="post.caption" class="instagram-feed__image" />
        <div class="instagram-feed__overlay">
          <div class="instagram-feed__engagement">
            <span><i class="fas fa-heart"></i> {{ post.like_count || '—' }}</span>
            <span><i class="fas fa-comment"></i> {{ post.comments_count || '—' }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstagramFeed',
  
  data() {
    return {
      posts: [],
      loading: true,
      error: null,
      maxPosts: 10
    }
  },
  
  mounted() {
    this.fetchInstagramPosts();
  },
  
  methods: {
    async fetchInstagramPosts() {
      try {
        this.loading = true;
        
        // Replace this with your actual API access token and endpoint
        // You'll need to set up an app on Facebook Developer platform and get proper Instagram API access
        const accessToken = 'YOUR_INSTAGRAM_ACCESS_TOKEN';
        const userId = 'INSTAGRAM_USER_ID'; // You'll need to get this from the API
        
        const response = await fetch(
          `https://graph.instagram.com/${userId}/media?fields=id,caption,media_url,permalink,thumbnail_url,timestamp,username&access_token=${accessToken}`
        );
        
        if (!response.ok) {
          throw new Error('Failed to fetch Instagram posts');
        }
        
        const data = await response.json();
        this.posts = data.data.slice(0, this.maxPosts);
      } catch (error) {
        console.error('Error fetching Instagram posts:', error);
        this.error = 'Unable to load Instagram posts. Please try again later.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.instagram-feed {
  max-width: 1200px;
  width: 100%;
  padding: 2rem 1rem;
}

.instagram-feed__title {
  text-align: left;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.instagram-feed__title a {
  text-decoration: none;
}

.instagram-icon {
  margin-right: 0.5rem;
  color: var(--primary-color);
}

.instagram-feed__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.instagram-feed__item {
  position: relative;
  overflow: hidden;
  aspect-ratio: 1/1;
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: 4px;
}

.instagram-feed__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.instagram-feed__item:hover .instagram-feed__image {
  transform: scale(1.05);
}

.instagram-feed__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 0.5rem;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.instagram-feed__item:hover .instagram-feed__overlay {
  opacity: 1;
}

.instagram-feed__engagement {
  display: flex;
  justify-content: space-around;
}

.instagram-feed__loading,
.instagram-feed__error {
  text-align: center;
  padding: 2rem;
}
</style>